import { config } from "@/config";
export class PagoVentaService {
    static get headers() {
        return {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            "Content-Type": "application/json",
        };
    }
    static async getTiposPago() {
        const res = await fetch(`${config.API_URL}/api/PagoVenta/tipos-pago`, {
            headers: this.headers,
        });
        return res.json();
    }
    static async getBancosPorTipoPago(tipoPagoId) {
        const res = await fetch(`${config.API_URL}/api/PagoVenta/bancos/${tipoPagoId}`, {
            headers: this.headers,
        });
        return res.json();
    }
    static async registrarPago(dto) {
        const res = await fetch(`${config.API_URL}/api/PagoVenta/registrar`, {
            method: "POST",
            headers: this.headers,
            body: JSON.stringify(dto),
        });
        const data = await res.json();
        if (!res.ok)
            throw new Error(data.errores || "Error al registrar el pago.");
        return data;
    }
    static async getPorOrden(ordenVentaId) {
        const res = await fetch(`${config.API_URL}/api/PagoVenta/orden/${ordenVentaId}`, {
            headers: this.headers,
        });
        return res.json();
    }
}
